import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PGWContractRateEventContainerModel } from "../../../../../models/aggregates/pgw/pgw-contract-rate-event.model";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import {
  PGWContractRateEventQueryCriteriaClass,
  PGWContractRateEventCriteriaModelQuery,
} from "../../criteria/pgw/pgw-contract-rate-event-criteria.model";

@Injectable({
  providedIn: "root",
})
export class PGWContractRateEventService extends BaseApiTemplateService<PGWContractRateEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "/contract-rates/events";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "/contract-rates/events";
    this.httpClient = http;
  }

  getContractRateEventByCriteria(
    visa: ApiVisa,
    criteria?: PGWContractRateEventQueryCriteriaClass
  ): Observable<PagingResponseModel<PGWContractRateEventContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildContractRateEventCriteriaCriteria = new PGWContractRateEventCriteriaModelQuery(criteria);
    console.log("query", buildContractRateEventCriteriaCriteria.query);
    return this.httpClient.get<PagingResponseModel<PGWContractRateEventContainerModel>>(
      this.apiUrl + "/query?" + buildContractRateEventCriteriaCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
